import { inject, Injectable } from "@angular/core";
import { of } from "rxjs";
import { catchError, finalize, first, map, switchMap } from "rxjs/operators";

import { PrivacyModel } from "@intocare/auth-data";
import { ModalService, SnackbarService } from "@intocare/ui";

import { TermsAndConditionsComponent } from "../components/terms-conditions/terms-conditions.component";

@Injectable({
	providedIn: "root",
})
export class PrivacyModalService {
	private modalService = inject(ModalService);
	private privacyModel = inject(PrivacyModel);
	private snackbarService = inject(SnackbarService);

	openTermsAndConditionsModal(hq: string, userId: string) {
		const modalRef = this.modalService.open(TermsAndConditionsComponent, {
			backdrop: true,
			width: 700,
			height: 600,
			disableClose: true,
		});

		return modalRef.instance.modalResult.pipe(
			first(),
			switchMap((result) => {
				if (!result) {
					return of(false);
				}

				return this.privacyModel.acceptTermsAndConditions(hq, userId).pipe(
					map(() => true),
					catchError(() => {
						this.snackbarService.show({ text: "labels.error.saving", error: true });

						return of(false);
					}),
				);
			}),
			finalize(() => modalRef.close()),
		);
	}
}
